import AdvanteIcons from "../AdvanteIcons"; 
import DeliverySteps from "./../../images/motionode/delivery-steps.png"

const Header = () => {
    return (
        <section className='development-header' >
           
            <div className="containerFull">
                <div className="development-header-wrapper">
                    <div className="development-header-copy">
                        <div className="development-header-icon">
                            <AdvanteIcons 
                                type="IcoSoftwareDevelopment" 
                                fill="var(--white-color)"
                            />
                        </div>
                        <h2><span className="text-violet-pink-blue-orange-red">AI-assisted software delivery</span> for real platforms.</h2>
                        <p>We help companies maintain, modernize, and improve existing software platforms using experienced engineers, AI-assisted development, human review, staging, QA, pull requests, and controlled deployment. Our process is powered by Motionode, our internal delivery platform that keeps tickets, code changes, reviews, and deployment steps connected.</p>
                        <p className="development-positioning">Faster than a traditional development process. Safer than uncontrolled AI coding. Built for real platforms already running in production.</p>
                    </div>
                    <div className="development-header-image">
                        <div className="development-setup-base">
                            <img 
                                src={ DeliverySteps }
                                alt="Motionode controlled delivery flow"
                                loading="lazy"
                            />
                        </div>
                        
                    </div>
                </div>
                
            </div>
        </section>
    );
  }
  
  export default Header;